import { DesignerContextInput, FlowContextInput } from '../../../features/hub/domain/designer-assistant';

export class ShowDesignerAssistant {
  static readonly type = '[Designer Assistant] Show';
}

export class HideDesignerAssistant {
  static readonly type = '[Designer Assistant] Hide';
}

export class ToggleDesignerAssistant {
  static readonly type = '[Designer Assistant] Toggle';
}

export class UpdateDesignerAssistantContext {
  static readonly type = '[Designer Assistant] Update Context';
  constructor(public context: DesignerContextInput | null) {}
}

export class UpdateDesignerAssistantFlowContext {
  static readonly type = '[Designer Assistant] Update Flow Context';
  constructor(public flowContext: FlowContextInput | null) {}
}

export class SetDesignerAssistantContextChangedSuggestion {
  static readonly type = '[Designer Assistant] Set Context Changed Suggestion';
  constructor(public value: boolean) {}
}
